import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from "./queryKeys";
import Api from "../api/Api";
import { IGetMetadata } from "../types/metadata";

export default function useGetMetadataQuery(datasetId: string, enabled: boolean = true): UseQueryResult<IGetMetadata, Error> {
  return useQuery({
    queryKey: [QUERY_KEYS.metadata.getMetadata, datasetId],
    queryFn: async (): Promise<IGetMetadata> => {
      try {
        return await Api.metadata.getMetadata(datasetId);
      } catch (error) {
        console.error('Error fetching metadata:', error);
        throw error;
      }
    },
    enabled
  });
}
